import { ReactElement } from "react";
import { localize } from "client_legacy/ndaw/culture";
import { FormattedText, Typography } from "client/Components";
import { DocumentItemType } from "client/Api/Documents/SharePoint/common";
import { DocumentShareNotificationDataViewModel } from "client/Api/Notifications/notifications";
import { setTrackingId } from "client/Misc/utils";

export type DocumentSharedActivityProps = {
	data: DocumentShareNotificationDataViewModel;
};

export const DocumentSharedActivity = (props: DocumentSharedActivityProps): ReactElement => {
	const { data } = props;

	const {
		sharingUserName,
		documentName,
		documentType
	} = data;

	const renderContent = (): ReactElement => {
		if (sharingUserName === null) {
			return (
				<FormattedText
					text={localize("_NameHasBeenSharedWithYou")}
					thingsToReplace={[
						{
							what: "{{Name}}",
							filler: (
								<Typography
									trackingId="document-name"
									weight="bold"
								>
									{documentName}
								</Typography>
							)
						}
					]}
				/>
			);
		} else if (documentType === DocumentItemType.Folder) {
			return (
				<FormattedText
					text={localize("_UserXSharedTheFolderYWithYou")}
					thingsToReplace={[
						{
							what: "{{UserName}}",
							filler: (
								<Typography
									trackingId="user-name"
									weight="bold"
								>
									{sharingUserName}
								</Typography>
							)
						},
						{
							what: "{{FolderName}}",
							filler: (
								<Typography
									trackingId="document-name"
									weight="bold"
								>
									{documentName}
								</Typography>
							)
						}
					]}
				/>
			);
		} else {
			return (
				<FormattedText
					text={localize("_UserXSharedTheFileYWithYou")}
					thingsToReplace={[
						{
							what: "{{UserName}}",
							filler: (
								<Typography
									trackingId="user-name"
									weight="bold"
								>
									{sharingUserName}
								</Typography>
							)
						},
						{
							what: "{{FileName}}",
							filler: (
								<Typography
									trackingId="document-name"
									weight="bold"
								>
									{documentName}
								</Typography>
							)
						}
					]}
				/>
			);
		}
	};

	return (
		<span {...setTrackingId("title")}>
			{renderContent()}
		</span>
	);
};

DocumentSharedActivity.displayName = "DocumentSharedActivity";